/* Icon.tsx generated by @compiled/babel-plugin v0.35.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import "./Icon.compiled.css";
import { forwardRef } from 'react';
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { SpanSkeleton } from '@atlaskit/linking-common';
// TODO: Figure out a more scalable/responsive solution
// for vertical alignment.
// Current rationale: vertically positioned at the top of
// the smart card container (when set to 0). Offset this
// to position it with appropriate whitespace from the top.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var Icon = forwardRef(function (_ref, __cmplr) {
  var _ref$as = _ref.as,
    C = _ref$as === void 0 ? "img" : _ref$as,
    __cmpls = _ref.style,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_2rkoyh40 _4t3i7vkz _1bsb7vkz _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe", __cmplp.className])
  }));
});

// TODO: Remove on platform-smart-card-icon-migration cleanup
// Used for 'untrue' icons which claim to be 16x16 but
// are less than that in height/width.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
if (process.env.NODE_ENV !== 'production') {
  Icon.displayName = 'Icon';
}
export var AKIconWrapper = forwardRef(function (_ref2, __cmplr) {
  var _ref2$as = _ref2.as,
    C = _ref2$as === void 0 ? "span" : _ref2$as,
    __cmpls = _ref2.style,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_2hwx1i6y", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  AKIconWrapper.displayName = 'AKIconWrapper';
}
export var Shimmer = function Shimmer(_ref3) {
  var testId = _ref3.testId;
  var skeletonCustomStyles = {
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
    top: '50%',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
    left: '50%',
    transform: 'translate(-50%, -50%)',
    marginRight: "var(--ds-space-050, 4px)"
  };
  return /*#__PURE__*/React.createElement(SpanSkeleton, {
    width: 16,
    height: 16,
    borderRadius: 2,
    testId: testId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: skeletonCustomStyles
  });
};